import { useContext } from 'react';
import { ApplicationContext } from '@/context/application-settings';

export default function useApplicationSettings() {
  const { appSettings, loading } = useContext(ApplicationContext);

  return { appSettings, loading };
}
